<template>
	<div class="main-container" @click="resetInactivity()">
    
    <transition name="slide-header" appear>
      <div class="heading-container">
          <h1>{{store.language === 'english' ?  images[store.selectedImage].title : images[store.selectedImage].titleSpanish }}</h1>
        <!--  <h3>{{ images[store.selectedImage].titleDesc }}</h3> -->
        <button id="language-button" @click="store.language === 'english'? store.language='spanish' : store.language='english'">{{ store.language === 'english'? 'ESPAÑOL' : 'ENGLISH' }}</button>
      </div>
    </transition>

    <div class="slider-container">
      <ComparisonSlider
        :value="50"
        :step="0.01"
        :beforeImage="images[store.selectedImage].beforeImage"
        :afterImage="images[store.selectedImage].afterImage"
      />
    </div>

    <transition name="slide-footer" appear>
      <div class="footer-container">
        <div class="compare-title">
          <h2>Hubble</h2>
        </div>
        <div class="description-container">
          <p>{{ store.language === 'english' ? images[store.selectedImage].hubbleDesc : images[store.selectedImage].hubbleDescSpanish}}</p>
          <br />
          <p class="credits">{{ images[store.selectedImage].hubbleCredits }}</p>
        </div>
        <div>
          <ImageSelect />
        </div>
        <div class="description-container">
          <p>{{ store.language === 'english' ? images[store.selectedImage].webbDesc :  images[store.selectedImage].webbDescSpanish}}</p>
          <br />
          <p class="credits">{{ images[store.selectedImage].webbCredits}}</p>
        </div>
        <div class="compare-title">
          <h2>JWST</h2>
        </div>
      </div>
    </transition>


	</div>
</template>

<script>
import { store } from '../store.js'
import { compareImages } from '../data.js'

import ComparisonSlider from '../components/ComparisonSlider.vue'
import ImageSelect from '../components/ImageSelect.vue'

export default {
	name: 'StartPage',
	data() {
      return {
        store,
        images: compareImages.images,
        inactivityTimer: null
      }
  },
  components: {
    ComparisonSlider,
    ImageSelect
  },
	props: {},
	mounted() {
 
    console.log('mount')
	},
	methods: {
    startInactivityTimer() {
      this.inactivityTimer = setTimeout(this.handleInactivity, 60000)
    },
    resetInactivity() {
      clearTimeout(this.inactivityTimer);
      this.startInactivityTimer()
    },
    handleInactivity() {
      location.reload()
    },
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  width: 100%;
  height: 100%;
  background-color: var(--purple);
}

.heading-container {
  height: 10vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background: var(--purple-transparent);

  position: absolute;
  left: 0;
  top: 0;
  z-index: 3; 
}

.heading-container h1 {
  font-family: Magazine-Regular;
  font-size: var(--font-size-five);
  text-shadow: #000000 1px 1px 15px;
}

.heading-container h3 {
  font-family: Magazine-Regular;
  font-size: var(--font-size-two);
  text-shadow: #000000 1px 1px 15px;
}

.slider-container {
  height: 100vh;
}

.footer-container {
  height: 17vh;
  display: grid;
  grid-template-columns: 0.5fr 2fr 2.5fr 2fr 0.5fr;
  padding: 1rem 0 0 0;
  background: var(--purple-transparent);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 3; 
}

.compare-title {
  display: flex;
  align-self: flex-end;
  justify-content: center;
  padding-bottom: 1rem;
}

.compare-title h2 {
  font-weight: bold;
  font-family: Magazine-Bold;
  font-size: var(--font-size-four);
}

.description-container {
  padding: 0rem 3rem;
}

.description-container h2 {
  margin-bottom: 0.5rem;
  text-align: left;
  font-family: HelveticaNeue;
  font-size: var(--font-size-three);
}

.description-container p {
  text-align: left;
  font-family: Magazine-Regular;
  font-size: var(--font-size-one);
}

.credits {
  font-size: 0.8rem !important;
}

#language-button{
  background: none;
  border: none;
  color: white;
  position: absolute;
  top: 0;
  right: 1rem;
  height: 10vh;
  font-size: var(--font-size-two);
  font-family: Magazine-Bold;
}

</style>
